module.exports = __webpack_public_path__ + "static/media/1023017.756492cb.png";